import { Button } from "@mui/material";

import { GridItem, GridRow } from "commons/ui/Grid";

import ProjectsForm from "components/form/ProjectsForm";

import { SaveContextProvider } from "context/save";

import useSaveUpdateWithSnackbar from "hooks/useSaveUpdateWithSnackbar";

function ButtonSave() {
    const { onButtonClick } = useSaveUpdateWithSnackbar({
        successMsg: "Progetto modificato con successo",
        errorMsg: "Errore nella modifica del progetto",
    });

    return (
        <GridRow justifyContent={"right"}>
            <GridItem className={"button-under-paper"}>
                <Button variant={"contained"} onClick={onButtonClick}>
                    Salva
                </Button>
            </GridItem>
        </GridRow>
    );
}

function ModificaProgetto() {
    return (
        <>
            <GridRow className={"title-top-paper"}>
                <GridItem>
                    <h1>Modifica Progetto</h1>
                </GridItem>
            </GridRow>

            <SaveContextProvider>
                <ProjectsForm />

                <ButtonSave />
            </SaveContextProvider>
        </>
    );
}

export default ModificaProgetto;
